import { Button } from "@volca/ui/components/ui/button";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import { formatPersistentEditValue } from "@/payroll/ai-script/ai-script-persistent-edits-utils";
import type { IAiSpreadsheetOverrideCandidate } from "@/payroll/ai-script/types";
import { EditCard } from "./shared";

interface RowPickerCandidateProps {
  candidate: IAiSpreadsheetOverrideCandidate;
  isEditable: boolean;
  isSelected: boolean;
  isPending: boolean;
  onView: () => void;
  onSelect: () => void;
}

export const RowPickerCandidate = ({
  candidate,
  isEditable,
  isSelected,
  isPending,
  onView,
  onSelect,
}: RowPickerCandidateProps) => (
  <EditCard>
    <Stack
      className="w-full"
      direction="row"
      gap={2}
      align="center"
      justify="between"
    >
      <Stack align="start" gap={0} className="min-w-0 flex-1">
        <Text
          variant="label"
          className="truncate"
          title={`${candidate.sheet_name} · ${candidate.address}`}
        >
          {candidate.sheet_name} · {candidate.address}
        </Text>
        <Text variant="caption" tone="muted" className="wrap-break-word">
          Currently {formatPersistentEditValue(candidate.value)}
        </Text>
      </Stack>
      <Stack direction="row" gap={2} align="center" className="shrink-0">
        <Button variant="outline" size="xs" onClick={onView}>
          View
        </Button>
        <Button
          variant="secondary"
          size="xs"
          onClick={onSelect}
          disabled={isSelected || !isEditable || isPending}
          loading={isSelected}
        >
          {isSelected ? "Applying…" : isEditable ? "Use this row" : "View only"}
        </Button>
      </Stack>
    </Stack>
  </EditCard>
);
